import styled from "styled-components"

export const NoticeContainer = styled.div`
  position: fixed;
  right: 1em;
  bottom: 1em;
  display: flex;
  z-index: 100;
  max-width: 20em;
`
